import { TextFieldController } from '@buildwise/libs/ui';
import { useFormContext } from 'react-hook-form';
import { FieldWrapper } from '@buildwise/libs/people';
import { ModifyUserFormSchema } from '../../hooks/useUserForm';

function UserDefaultFields() {
  const {
    formState: { isSubmitting },
  } = useFormContext();

  return (
    <>
      <FieldWrapper id="firstname" label="First Name" required disabled={isSubmitting}>
        <TextFieldController<ModifyUserFormSchema>
          name="firstname"
          TextFieldProps={{ id: 'firstname', autoFocus: true }}
        />
      </FieldWrapper>

      <FieldWrapper id="lastname" label="Last Name" required disabled={isSubmitting}>
        <TextFieldController<ModifyUserFormSchema>
          name="lastname"
          TextFieldProps={{ id: 'lastname' }}
        />
      </FieldWrapper>

      <FieldWrapper id="email" label="Email" disabled={isSubmitting}>
        <TextFieldController<ModifyUserFormSchema>
          name="email"
          TextFieldProps={{
            id: 'email',
            tabIndex: -1,
            disabled: true,
            InputProps: { readOnly: true },
          }}
        />
      </FieldWrapper>

      {/* <FieldWrapper id="primaryCompanyName" label="Company Name" disabled={isSubmitting}>
        <TextFieldController<ModifyUserFormSchema>
          name="primaryCompanyName"
          TextFieldProps={{
            id: 'primaryCompanyName',
            tabIndex: -1,
            disabled: true,
            InputProps: { readOnly: true },
          }}
        />
      </FieldWrapper> */}
    </>
  );
}

export default UserDefaultFields;
